export default "__VITE_ASSET__5b96d67e__"